import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const UploadIcon = React.forwardRef((props, ref) => (
  <SvgIcon ref={ref} viewBox="0 0 104 75" {...props}>
    <path
      id="Tracé_10632"
      data-name="Tracé 10632"
      d="M56.015,969.362a30.333,30.333,0,0,0-30.078,25.366,24.885,24.885,0,0,0,4,49.455H85.49a21.5,21.5,0,0,0,.921-42.972,30.306,30.306,0,0,0-30.4-31.849Zm0,4.534a26.031,26.031,0,0,1,25.862,29.192,2.267,2.267,0,0,0,2.267,2.551H85.49a17.005,17.005,0,0,1,0,34.01H29.941a20.414,20.414,0,0,1-1.878-40.741,2.267,2.267,0,0,0,2.055-1.984,25.992,25.992,0,0,1,25.9-23.027Zm0,22.673a2.267,2.267,0,0,0-2.267,2.268v24.374l-8.68-7.9a2.371,2.371,0,0,0-3.224.141,2.33,2.33,0,0,0,.177,3.224l12.47,11.337a2.461,2.461,0,0,0,1.523.567,1.988,1.988,0,0,0,1.523-.567l12.47-11.337a2.3,2.3,0,0,0,.177-3.224,2.416,2.416,0,0,0-3.224-.141l-8.68,7.9V998.837A2.267,2.267,0,0,0,56.015,996.57Z"
      transform="translate(-5 -969.362)"
    />
  </SvgIcon>
));

export default React.memo(UploadIcon);
